import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { buyers, images } from "../data/content";
import type { Buyer } from "../types/content";
const FIRST_DELAY = 6000;
const SHOW_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [buyer, setBuyer] = useState<Buyer | null>(null);
  const [minutesAgo, setMinutesAgo] = useState(2);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let index = Math.floor(Math.random() * buyers.length);
    let hideTimer: number;
    let nextTimer: number;
    const show = () => {
      setBuyer(buyers[index % buyers.length]);
      setMinutesAgo(1 + Math.floor(Math.random() * 14));
      index += 1;
      hideTimer = window.setTimeout(() => {
        setBuyer(null);
        nextTimer = window.setTimeout(show, GAP);
      }, SHOW_FOR);
    };
    nextTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed inset-x-3 bottom-[92px] z-50 flex justify-start sm:left-5 sm:right-auto" data-id="element-278" data-mp="116mgstdueq5i">
      <AnimatePresence data-id="element-279" data-mp="1fxmylp0hbweb">
        {buyer && !dismissed && <motion.div key={buyer.name} role="status" initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full max-w-sm items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_16px_40px_-12px_rgba(11,31,58,0.45)] ring-1 ring-navy/10" data-id="element-280" data-mp="1ay0ldfknig5i">
            <img src={images.hero} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-cream object-contain" data-id="element-281" data-mp="28imw722gstl2" />
            <div className="min-w-0" data-id="element-282" data-mp="23nhcm9wjbr05">
              <p className="text-[14px] leading-snug text-ink" data-id="element-283" data-mp="2ap2yx4lqeg8j">
                <strong data-id="element-284" data-mp="2aqnxr6f2wlc7">{buyer.name}</strong> from <strong data-id="element-285" data-mp="2fn4sijgs9xy9">{buyer.country}</strong> just purchased this digital book
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[12px] font-semibold text-cta" data-id="element-286" data-mp="2km7pdgmm0xv5">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-287" data-mp="2pmdk55o6f0hg" />
                Verified purchase · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 ease-out hover:bg-cream hover:text-ink" data-id="element-288" data-mp="1rw8tb1a000gz">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-289" data-mp="26osrdniajhrk" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}